import React from "react";

export default function GlobalAppDisable(props) {
  const { isActive } = props;

  const coverStyle = () => ({
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    alignContent: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    zIndex: 100000,
    backgroundColor: "rgba(221, 221, 221, 0.4)",
  });

  const containerStyle = () => ({
    position: "relative",
    display: "block",
    zIndex: 100001,
  });

  return isActive ? (
    <div style={coverStyle()}>
      <div style={containerStyle()}>
        {props.children}
      </div>
    </div>
  ) : null;
}






